import { render, staticRenderFns } from "./Lawyer.vue?vue&type=template&id=49bf3f92&scoped=true&"
import script from "./Lawyer.vue?vue&type=script&lang=js&"
export * from "./Lawyer.vue?vue&type=script&lang=js&"
import style0 from "./Lawyer.vue?vue&type=style&index=0&id=49bf3f92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bf3f92",
  null
  
)

/* custom blocks */
import block0 from "./Lawyer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VBtn,VChip,VContainer,VDivider,VListItem,VListItemTitle,VNavigationDrawer})
